import React, {Component} from 'react';
import classNames from 'classnames';

import {CSSTransition, TransitionGroup} from 'react-transition-group';

import {haveDifferentKeys} from '../utils/compare';

import './Group.css';

const duration = 300,
    onEnter = node => {
        node.style.marginTop = `${ - node.offsetHeight}px`;
        node.style.marginBottom = `0px`;
    },
    onExit = node => {
        node.style.marginTop = "";
        node.style.marginBottom = "";
    },
    onEntering = node => {
        node.style.marginTop = "";
        node.style.marginBottom = "";
    },
    onExiting = node => {
        node.style.marginTop = `${ - node.offsetHeight}px`;
        node.style.marginBottom = `0px`;
    };

export default class Group extends Component {

    state = {
        items: []
    };

    setItems = children => this.setState({
        items: React
            .Children
            .toArray(children)
    });

    componentDidMount() {
        const {children} = this.props;
        this.setItems(children);
    }

    componentWillReceiveProps({children}) {
        this.setItems(children);
    }

    shouldComponentUpdate(props, {items}) {
        return haveDifferentKeys(items, this.state.items);
    }

    render() {
        const {
                className,
                ...props
            } = this.props, {items} = this.state;
        return <TransitionGroup className={classNames(className, 'Group')} {...props}>
            {
                items.map(
                    item => <CSSTransition
                        className={classNames(item.props.className, 'Group-item')}
                        classNames="Group-item"
                        key={item.key}
                        timeout={duration}
                        onEnter={onEnter}
                        onExit={onExit}
                        onEntering={onEntering}
                        onExiting={onExiting}>
                        {item}
                    </CSSTransition>
                )
            }
        </TransitionGroup>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Group.js